module.exports = __webpack_public_path__ + "imgcvh/hero-1.62c5f29e.jpg";